import React from 'react';
import { object, PropTypes } from 'prop-types';
import { renderRoutes } from 'react-router-config';
import { withStyles } from '@material-ui/core/styles';
import styles from './appStyles-jss';

class ViewEmail extends React.Component {
  render() {
    const {
      classes,
      route,
    } = this.props;
    return (
      <div className={classes.appFrameOuter}>
        <main className={classes.outerContent} id="mainContent">
          <div className={classes.outerEmptyContentMail}>
            {renderRoutes(route.routes)}
          </div>
        </main>
      </div>
    );
  }
}

ViewEmail.propTypes = {
  classes: PropTypes.object.isRequired,
  route: object,
};

ViewEmail.defaultProps = {
  route: object
};

export default (withStyles(styles)(ViewEmail));
